import { ChangeEvent, InputHTMLAttributes, forwardRef } from "react";

import { InputStyle } from "./styles";

export type InputProps = {
  id: string;
  value?: string | null;
  onChangeValue?: (value: string) => void;
  hasError?: boolean;
  size?: "medium" | "large";
  before?: React.ReactNode;
  after?: React.ReactNode;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "id" | "size">;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      onChangeValue,
      className,
      style,
      hasError,
      disabled,
      size = "medium",
      onChange,
      before,
      after,
      ...restProps
    },
    ref
  ) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event);
      onChangeValue?.(event.target.value);
    };

    return (
      <InputStyle
        disabled={disabled}
        hasError={hasError}
        size={size}
        className={className}
        style={style}
      >
        {before && <div>{before}</div>}
        <InputStyle.Input
          disabled={disabled}
          ref={ref}
          onChange={handleChange}
          aria-invalid={hasError ? "true" : "false"}
          {...restProps}
        />
        {after && <div>{after}</div>}
      </InputStyle>
    );
  }
);

Input.displayName = "Input";
